import { filter, get, includes, isEmpty, keys, map, values } from 'lodash/fp';
import React, { Fragment, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Checkbox, CheckboxGroup, Modal } from 'rsuite';
import PrintPdfButton from '../../components/PrintPdfButton';
import VisitOrderDetailsPdf from '../../components/visit/VisitOrderDetailsPdf';
import { fetchVisitOrderByTrackingMethods } from '../../redux/sagas/routines';
import {
  getAll as getVisitOrder,
  getIsFetching as getIsFetchingOrder
} from '../../redux/selectors/visit/order';
import { parseInt } from '../../helpers/utils';

const mapWithKey = map.convert({ cap: false });

export default () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState();
  const [selectedTrackingMethods, setSelectedTrackingMethods] = useState([]);
  const visitDetails = JSON.parse(
    localStorage.getItem('createVisit_visitOrderDetails')
  );
  const visitId = get('visit.id', visitDetails);
  const trackingMethods = get('trackingMethodsWithOrder', visitDetails);
  const visitOrder = useSelector(getVisitOrder);
  const isLoadingOrder = useSelector(getIsFetchingOrder);

  const selectedOrder = useMemo(
    () => {
      const trackingMethodIds = map(parseInt, selectedTrackingMethods);
      const orderByTrackingMethodId = filter(
        ({ trackingMethod }) => includes(trackingMethod.id, trackingMethodIds),
        visitOrder
      );
      return values(orderByTrackingMethodId);
    },
    [selectedTrackingMethods, visitOrder]
  );

  const handleShowModal = () => {
    const trackingMethodIds = keys(trackingMethods);
    dispatch(fetchVisitOrderByTrackingMethods({ visitId, trackingMethodIds }));
    setSelectedTrackingMethods(trackingMethodIds);
    setShow(true);
  };

  const handleHideModal = () => {
    setShow(false);
  };

  const handlePrintCallback = () => {
    setShow(false);
  };

  const handleSelectTrackingMethods = value => {
    setSelectedTrackingMethods(value);
  };

  return (
    <Fragment>
      <Button
        onClick={handleShowModal}
        id="printOrder"
        style={{ display: 'none' }}
      >
        Show Modal Trigger
      </Button>
      <Modal show={show} onHide={handleHideModal}>
        <Modal.Header>
          <Modal.Title>Select &quot;Help Desired&quot; with Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {trackingMethods && (
            <CheckboxGroup
              name="checkboxList"
              value={selectedTrackingMethods}
              onChange={handleSelectTrackingMethods}
            >
              {mapWithKey(
                (label, id) => (
                  <Checkbox key={`item-${id}`} value={id} checked>
                    {label}
                  </Checkbox>
                ),
                trackingMethods
              )}
            </CheckboxGroup>
          )}
        </Modal.Body>
        <Modal.Footer>
          <PrintPdfButton
            appearance="primary"
            fileName={`${get('visit.id', visitDetails)}-visit-order`}
            disabled={isLoadingOrder || isEmpty(selectedOrder)}
            content={
              <VisitOrderDetailsPdf
                data={{ ...visitDetails, orders: selectedOrder }}
              />
            }
            callback={handlePrintCallback}
          />
          <Button onClick={handleHideModal} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};
